module.exports = __webpack_public_path__ + "static/media/appPlay.78ca7e91.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/UpZone/appPlay.gif
// module id = 207
// module chunks = 0